module.exports = __webpack_public_path__ + "img/icon_IPFS_outlined_w.670e9cd1.svg";